module.exports = {"652701001":"青得里街道","652701002":"顾力木图街道","652701004":"南城区街道","652701100":"小营盘镇","652701101":"达勒特镇","652701102":"乌图布拉格镇","652701103":"青得里镇","652701201":"贝林哈日莫墩乡","652701400":"阿热勒托海牧场","652701408":"五台工业园区","652701501":"兵团八十一团","652701502":"兵团八十四团","652701504":"兵团八十六团","652701505":"兵团八十九团","652701506":"兵团九十团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652701.json
// module id = 2862
// module chunks = 0